import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import PrivacyPage from "@/pages/privacy/page";
import CookiePage from "@/pages/cookie/page";
import DisclaimerPage from "@/pages/disclaimer/page";
import TerminiPage from "@/pages/termini/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/cookie",
    element: <CookiePage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/termini",
    element: <TerminiPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;